var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('KeyStyle',{ref:"TextArea",attrs:{"input-str":_vm.inputStr}}),_c('SimpleKeyboard',{ref:"Keyboard",attrs:{"input":_vm.input,"show-gesture":true,"next-input":_vm.nextKey},on:{"onChange":_vm.onChange,"onKeyPress":_vm.onKeyPress}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }